export default function Image(props) {

    const onError = (e) => {
        e.target.onerror = function () { }
        
        e.target.src = props.placeholder
    }

    return <img {...props} onError={onError} alt=''/>
}